import { NAV_MENU_TYPE } from '@eureka/shared/nav-bar';
import { E_ShareType } from '@eureka/services/src/types/share';
import { AuthService } from '@eureka/shared/share-tools/src/domain/services/auth-service';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { createRouter, createWebHashHistory } from 'vue-router';

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            component: () => import('@/pages/Layout.vue'),
            redirect: '/essentiality-claim',
            children: [
                {
                    path: '/home',
                    name: 'home',
                    redirect: '/essentiality-claim',
                },
                {
                    path: '/tourist',
                    name: 'tourist',
                    component: () => import('@/pages/tourist/index.vue'),
                },
                {
                    path: '/tourist/pricing',
                    name: 'touristPricing',
                    component: () => import('@/pages/tourist/pricing.vue'),
                },
                {
                    name: 'userSetting',
                    path: '/user-setting',
                    component: () => import(/* webpackChunkName: "air-usersetting" */'@/pages/user-setting/Layout.vue'),
                    beforeEnter: async(to, from, next) => {
                        if (to.name === 'userSettingPackage') {
                            return next({
                                name: 'userSettingPackageRD',
                                query: to.query,
                            })
                        }
                        next();
                    },
                    children: [
                        {
                            path: 'amount',
                            name: 'userSettingAmount',
                            component: () => import(/* webpackChunkName: "air-usersetting" */'@/pages/user-setting/Amount.vue'),
                        },
                        {
                            path: 'package',
                            name: 'userSettingPackage',
                            component: () => import(/* webpackChunkName: "air-usersetting" */'@/pages/user-setting/Package.vue'),
                        },
                        {
                            path: 'package/rd',
                            name: 'userSettingPackageRD',
                            component: () => import(/* webpackChunkName: "air-usersetting-RD" */'@/pages/user-setting/new-version/product-lines/RD.vue'),
                        }
                    ],
                },
                {
                    name: 'roadmap',
                    path: 'roadmap',
                    children: [
                        {
                            path: '',
                            name: 'roadmapHome',
                            component: () => import('@/pages/roadmap/index.vue'),
                        },
                        {
                            path: 'create',
                            name: 'roadmapCreate',
                            component: () => import('@/pages/roadmap/create.vue'),
                        }
                    ],
                },
                {
                    name: 'graph',
                    path: '/graph',
                    meta: {
                        navModuleType: NAV_MENU_TYPE.WORK_PROJECT,
                    },
                    children: [
                        {
                            path: '',
                            name: 'GraphHome',
                            component: () => import('@/pages/graph/index.vue'),
                        },
                        {
                            path: ':graph_id',
                            name: 'GraphDetail',
                            component: () => import('@/pages/graph/detail.vue'),
                            beforeEnter: async(to, from, next) => {
                                const authService = injectService<AuthService>(AuthService);
                                await authService.shareAccessCheck({
                                    data_id: to.params.graph_id as string,
                                    data_type: E_ShareType.PROJECT,
                                });
                                next();
                            },
                        },
                        {
                            path: ':graph_id/report',
                            name: 'GraphReport',
                            component: () => import('@/pages/graph/report.vue'),
                        },
                        {
                            path: ':graph_id/pdf/:item_id',
                            name: 'GraphPdf',
                            component: () => import('@/pages/graph/pdf.vue'),
                        }
                    ],
                },
                {
                    name: 'essentialityClaim',
                    path: '/essentiality-claim',
                    component: () => import('@/presentation/pages/essentiality-claim/EssentialityClaimLayout.vue'),
                    children: [
                        {
                            path: '',
                            name: 'EssentialityClaimHome',
                            component: () => import('@/presentation/pages/essentiality-claim/EssentialityClaimHomePage.vue'),
                        },
                        {
                            path: 'flow',
                            name: 'EssentialityClaimFlow',
                            component: () => import('@/presentation/pages/essentiality-claim/EssentialityClaimFlowPage.vue'),
                            children: [
                                {
                                    path: 'analysis',
                                    name: 'EssentialityClaimAnalysis',
                                    component: () => import('@/presentation/pages/essentiality-claim/EssentialityClaimAnalysisPage.vue'),
                                    meta: { step: 1 },
                                },
                                {
                                    path: 'chart',
                                    name: 'EssentialityClaimChart',
                                    component: () => import('@/presentation/pages/essentiality-claim/EssentialityClaimChartPage.vue'),
                                    meta: { step: 2 },
                                },
                                {
                                    path: 'conclusion',
                                    name: 'EssentialityClaimConclusion',
                                    component: () => import('@/presentation/pages/essentiality-claim/EssentialityClaimConclusionPage.vue'),
                                    meta: { step: 3 },
                                }
                            ],
                        }
                    ],
                }
            ],
        }
    ],
});

export default router;
